export interface Organization {
  id: string;
  name: string;
  discountCode: string;
}

export const ORGANIZATIONS: Organization[] = [
  {
    id: '2868ef69-054c-40bd-93ae-85cf08e4c71f',
    name: 'TUI',
    discountCode: 'TUI10'
  },
  {
    id: '3868ef69-054c-40bd-93ae-85cf08e4c71f',
    name: "NAZAR",
    discountCode: 'nazar'
  },
  {
    id: 'a848ccd3-fd8d-4035-925e-571ebb4e93e8',
    name: 'FLYGETS',
    discountCode: 'NONE'
  },
  {
    id: 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B',
    name: "SKAVSTA",
    discountCode: 'NONE'
  },
  {
    id: 'D9EB0AF8-5B3D-4281-8725-372E2D6A7804',
    name: "MDPARK",
    discountCode: 'NONE'
  },
  {
    id: '942ce067-7848-4441-b746-8f6eed7395bb',
    name: "QUALITY-XPO-ARLANDA",
    discountCode: 'NONE'
  },
  {
    id: '942ce067-7848-4441-b746-8f6eed7395bb',
    name: "QUALITY",
    discountCode: 'NONE'
  },
  {
    id: '55D7084D-3CF0-4CCC-9448-F924AFCDF3BC',
    name: "AIDEN-SHORT-TERM",
    discountCode: 'NONE'
  },
  {
    id: '55D7084D-3CF0-4CCC-9448-F924AFCDF3BC',
    name: "AIDEN",
    discountCode: 'NONE'
  }
];
